import {NewPersonView} from '@modifi/onboarding-api-clients'
import {pick} from 'ramda'

const personFields: (keyof NewPersonView)[] = [
  'aadhaarNumber',
  'city',
  'countryCode',
  'dateOfBirth',
  'emailAddress',
  'firstName',
  'lastName',
  'nationality',
  'politicallyExposed',
  'politicallyExposedReason',
  'providerPersonId',
  'salutation',
  'state',
  'streetName',
  'streetNumber',
  'zipCode',
  'panNumber',
]

export const pickPersonFields = pick(personFields)
